import Joi from "joi";
import routes from "../consts/routes.json";
import { getFunktionaleRolleByID } from "../consts/valueLists";
import { getCurrentUser } from "../services/JwtService";
import {
    nullableNumber,
    nullableString,
    optionalArray,
    optionalBool,
    required,
    requiredEnumWerteListeObjekt,
    requiredString,
    requiredWerteListeObjekt,
} from "../utils/Validator";
import { createLageSchema } from "./Lage";
import { ZUST_SBD } from "../consts/funktionaleRollen";

export const createInitialBetrieb = (betriebstyp) => {
    const currentUser = getCurrentUser();
    return {
        adresse: {
            strasse: "",
            hausnummer: "",
            plz: "",
            ort: "",
        },
        arbeitsstaettenNr: "",
        behoerdenkennung: "RLP",
        betreiber: {
            bezeichnung: "",
            adresse: {
                strasse: "",
                hausnummer: "",
                plz: "",
                ort: "",
            },
        },
        betreiberAdresse: true,
        betriebsstatus: {
            id: "GEPLANT",
            value: "geplant",
        },
        betriebstyp: betriebstyp,
        bezeichnung: "",
        haupttaetigkeit: null,
        iedRelevanz: false,
        katasterNr: "",
        lage: {
            hochwert: "",
            rechtswert: "",
        },
        muttergesellschaft: "",
        nacecode: null,
        prtrVos: [],
        prtrRelevanz: false,
        url: "",
        id: "",
        produktion: {
            anzahlBeschaeftigte: "",
            bezugsjahrProduktion: "",
            produktbezeichnungen: [],
            produktionsarten: [],
            produktionstage: "",
            produktionsverfahren: [],
            taetigkeiten: [],
            tagesarbeitszeitBis: null,
            tagesarbeitszeitVon: null,
            tagesarbeitszeitBisAsDate: null,
            tagesarbeitszeitVonAsDate: null,
        },
        wasserversorgung: {
            betriebInSchutzgebiet: false,
            bezugsjahr: "",
            eigenversorgung: false,
            oeffentlWasserversorgung: false,
            wasserbezug: "",
            wvbNr: "",
        },
        zustaendigeBearbeiter:
            currentUser && currentUser.funktionaleRollen.includes(ZUST_SBD)
                ? [
                    {
                        bearbeiter: {
                            datascoutId: currentUser.datascoutId,
                            vorname: currentUser.vorname,
                            name: currentUser.name,
                            funktionaleRollen: currentUser.funktionaleRollen
                                .map((funktionaleRolle) => getFunktionaleRolleByID(funktionaleRolle).value)
                                .join(", "),
                        },
                    },
                ]
                : [],
        zustaendigePersonen: [],
        kontakte: [],
        auditInfo: null,
    };
};

export const createBetriebSchema = () => {
    return {
        arbeitsstaettenNr: nullableString(),
        bezeichnung: requiredString(),
        betriebsstatus: required(Joi.any()),
        adresse: {
            strasse: requiredString(),
            hausnummer: requiredString(),
            plz: requiredString(),
            ort: requiredString(),
        },
        betreiber: {
            adresse: {
                strasse: requiredString(),
                plz: requiredString(),
                ort: requiredString(),
            },
            bezeichnung: requiredString(),
        },
        lage: createLageSchema(),
        haupttaetigkeit: requiredWerteListeObjekt(),
        nacecode: requiredEnumWerteListeObjekt(),
        produktion: {
            anzahlBeschaeftigte: nullableNumber(),
            bezugsjahrProduktion: nullableNumber()
                .min(1900)
                .max(2100)
                .error((tmpErrors) => {
                    tmpErrors[0].message = "Das Jahr muss zwischen 1900 und 2100 liegen.";
                    return tmpErrors[0];
                }),
            produktbezeichnungen: optionalArray(),
            produktionsarten: optionalArray(),
            produktionstage: nullableNumber(),
            produktionsverfahren: optionalArray(),
            taetigkeiten: optionalArray(),
        },
        wasserversorgung: {
            betriebInSchutzgebiet: optionalBool(),
            bezugsjahrWv: nullableNumber()
                .min(1900)
                .max(2100)
                .error((tmpErrors) => {
                    tmpErrors[0].message = "Das Jahr muss zwischen 1900 und 2100 liegen.";
                    return tmpErrors[0];
                }),
            eigenversorgung: optionalBool(),
            oeffentlWasserversorgung: optionalBool(),
            wasserbezug: nullableNumber(),
            wvbNr: nullableNumber(),
        },
        zustaendigeBearbeiter: optionalArray(),
        zustaendigePersonen: optionalArray(),
    };
};

export function calculateBetriebLink(betrieb, modus = "l") {
    return `${routes.BETRIEBSAKTE_RAW}/${betrieb.id}/betriebsdaten?modus=${modus}`;
}
